import React, { FC } from 'react'
import styled, { css } from 'styled-components'
import { media } from 'constants/media/media'
import { zIndex } from 'constants/zIndex/zIndex'
import { useDispatch } from 'react-redux'
import { toggleMobileFiltersMenu } from 'reducers/catNavReducer'
import Button from 'components/base/buttons/buttons'

interface Props {
	active: boolean
}

const StyledMenu = styled.div<Props>`
	${({ active }) => css`
		${media.tabletAndMobileOnly`
			position: fixed;
			top: 10.2rem;
			left: 0;
			z-index: ${zIndex.mobileFilterMenu};
			width: 30rem;
			max-width: 90%;
			height: 100vh;
			overflow-y: auto;
			padding: 3.5rem 2.5rem;
			border: 1px solid ${({ theme }) => theme.colors.borderColor};
			background-color: #fff;
			transform: translate3d(-100%, 0, 0);
			transition: transform 300ms ease;

			${active &&
				css`
					transform: translate3d(0, 0, 0);
				`}

		`}

		${media.tablet`
			top: 12.2rem;
			min-height: calc(100% - 12.2rem);
		`}
	`}
`

const StyledMenuOverlay = styled.div<Props>`
	${({ active }) => css`
		${media.tabletAndMobileOnly`
			position: fixed;
			top: 0rem;
			left: 0;
			z-index: ${zIndex.mobileFilterMenu - 1};
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.3);
			opacity: 0;
			pointer-events: none;
			visibility: hidden;
			transition: opacity 300ms linear;

			${active &&
				css`
					opacity: 1;
					pointer-events: all;
					visibility: visible;
				`}
		`}
	`}
`

const TogglableMenu: FC<Props> = ({ active, children }) => {
	const dispatch = useDispatch()
	const closeMenu = () => dispatch(toggleMobileFiltersMenu(false))

	return (
		<>
			<StyledMenu active={active}>{children}</StyledMenu>
			<StyledMenuOverlay active={active} onClick={closeMenu} />
		</>
	)
}

export default TogglableMenu
